import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { OKTA_LOGIN_URL } from "@core/consts/okta-login-url.const";
import { AuthService } from "@services/auth.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService) { }

  canActivate(): Observable<boolean> {
    return this.auth.user$.pipe(
      map(user => {
        if (!user) {
          window.location.replace(OKTA_LOGIN_URL);
          return false;
        }
        return true;
      })
    );
  }
}
